import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";
import { addLocaleToPath, getLocaleFromPath } from "@/client/utils/url-locales";

export const GuestGuard = () => {
  const isLoggedIn = useAuthStore((state) => !!state.user);
  const location = useLocation();

  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get("redirect");
  
  // Get locale from current URL path or from localStorage
  const currentLocale = getLocaleFromPath(location.pathname) || 
    (typeof window !== "undefined" ? window.localStorage.getItem("locale") : null);
  
  // Use redirect param if provided, otherwise use localized dashboard
  const redirect = redirectParam 
    ? decodeURIComponent(redirectParam) 
    : (currentLocale ? addLocaleToPath("/dashboard", currentLocale) : "/dashboard");

  if (isLoggedIn) {
    return <Navigate to={redirect} />;
  }

  return <Outlet />;
};
